export default "__VITE_ASSET__DLXaVqmT__";